<template>
  <v-navigation-drawer width="40%" v-model="localDrawer" right temporary app>
    <v-list-item class="primary">
      <v-list-item-content>
        <v-list-item-title class="font-weight-medium white--text">
          Histórico do lançamento de planos
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title class="font-weight-medium text-h6">
          Histórico de lançamento do {{ bimestre + 1 }}° bimestre
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <v-divider></v-divider>

    <div v-if="loading" class="text-center pa-4">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
      <p class="mt-2">Carregando histórico...</p>
    </div>

    <div v-else-if="planos.length > 0">
      <div v-for="(plano, planoIndex) in planos" :key="plano.id" class="mb-4">
        <v-list-item class="red darken-4 pa-4" v-if="plano.deleted_at">
          <v-row>
            <v-col cols="1" class="d-flex align-center">
              <v-icon size="40" color="white">mdi-delete</v-icon>
            </v-col>

            <v-col cols="11">
              <v-list-item-title class="white--text font-weight-medium">
                Plano(s) Deletado(s)
              </v-list-item-title>

              <p class="white--text subtitle-2 font-weight-light mb-0">
                Entre em contato com a gestão escolar para esclarecimentos.
              </p>
            </v-col>
          </v-row>
        </v-list-item>

        <v-list
          class="px-3"
          v-for="(audit, index) in plano.audits"
          :key="audit.id"
          dense
          :class="plano.deleted_at ? 'red lighten-5' : ''"
        >
          <v-alert dense outlined type="primary" class="d-flex align-center my-thick-border">
            <v-list-item-title class="d-flex align-center">
              <p class="font-weight-light subtitle-1 black--text mb-0">
                Nome:
                <strong>{{ audit.username || "- - -" }}</strong>
              </p>
            </v-list-item-title>
          </v-alert>
          <v-list-item-title>
            <p class="font-weight-light subtitle-1 text-caption mt-3">
              Tipo de operação:
              <strong>{{ audit.event ? events[audit.event] : "- - -" }}</strong>
            </p>
          </v-list-item-title>
          <span>
            <v-list-item-title v-if="Object.keys(audit.old_values).length > 0">
              <strong>Anterior</strong>
              <p
                v-for="(value, index) in audit.old_values"
                :key="index"
                class="font-weight-light subtitle-1 text-caption text-wrap"
              >
                <span v-if="index === 'status_id'">
                  Status: {{ getSituacaoPlano(value).descricao ?? "- - -" }}
                </span>

                <span v-else-if="index === 'objeto_aprendizagem'">
                  <strong> OBJETIVOS DE APRENDIZAGEM E DESENVOLVIMENTO </strong>:
                  <ul>
                    <li v-for="(habId, i) in parseArray(value)" :key="i">
                      {{ getDescricaoHabilidade(habId) }}
                    </li>
                  </ul>
                </span>

                <span v-else-if="index === 'experiencia'">
                  <strong> CAMPOS DE EXPERIÊNCIA </strong>:
                  <ul>
                    <li v-for="(exp, i) in parseArray(value)" :key="i">
                      {{ exp }}
                    </li>
                  </ul>
                </span>

                <span v-else-if="index === 'tematica'">
                  <strong> UNIDADES TEMÁTICAS / PRÁTICAS DE LINGUAGEM </strong>:
                  {{ value }}
                </span>

                <span
                  v-else-if="
                    index !== 'ods' &&
                    index !== 'id' &&
                    index !== 'disciplina_id' &&
                    index !== 'instrutorDisciplinaTurma_id' &&
                    index !== 'bimestre'
                  "
                >
                  <strong>{{ index.split("_").join(" ").toUpperCase() }}</strong
                  >: {{ value }}
                </span>
              </p>
              <v-btn
                v-if="podeRestaurarPlano && plano.deleted_at === null"
                block
                color="primary"
                class="font-weight-light subtitle-1 text-caption mb-2"
                @click="restaurarPlano(plano.instrutorDisciplinaTurma_id, plano.id, audit.id)"
              >
                <strong>Restaurar Versão Anterior</strong>
              </v-btn>
            </v-list-item-title>

            <v-divider class="my-2"></v-divider>

            <v-list-item-title v-if="hasRelevantNewValues(audit)">
              <strong>Depois</strong>
              <p
                v-for="(value, index) in audit.new_values"
                :key="index"
                class="font-weight-light subtitle-1 text-caption text-wrap"
              >
                <span v-if="index === 'status_id'">
                  Status: {{ getSituacaoPlano(value).descricao ?? "- - -" }}
                </span>

                <span v-else-if="index === 'objeto_aprendizagem'">
                  <strong>OBJETIVOS DE APRENDIZAGEM E DESENVOLVIMENTO</strong>:
                  <ul>
                    <li v-for="(habId, i) in parseArray(value)" :key="i">
                      {{ getDescricaoHabilidade(habId) }}
                    </li>
                  </ul>
                </span>

                <span v-else-if="index === 'experiencia'">
                  <strong> CAMPOS DE EXPERIÊNCIA </strong>:
                  <ul>
                    <li v-for="(exp, i) in parseArray(value)" :key="i">
                      {{ exp }}
                    </li>
                  </ul>
                </span>

                <span v-else-if="index === 'tematica'">
                  <strong> UNIDADES TEMÁTICAS / PRÁTICAS DE LINGUAGEM </strong>:
                  {{ value }}
                </span>

                <span v-else-if="index === 'direitos_aprendizagem'">
                  <strong>DIREITOS APRENDIZAGEM</strong>:
                  <ul>
                    <li v-for="(exp, i) in parseArray(value)" :key="i">
                      {{ exp }}
                    </li>
                  </ul>
                </span>

                <span
                  v-else-if="
                    index !== 'ods' &&
                    index !== 'id' &&
                    index !== 'disciplina_id' &&
                    index !== 'instrutorDisciplinaTurma_id' &&
                    index !== 'direito_aprendizagem' &&
                    index !== 'bimestre'
                  "
                >
                  <strong>{{ index.split("_").join(" ").toUpperCase() }}</strong
                  >: {{ value }}
                </span>
              </p>
            </v-list-item-title>
          </span>
          <v-list-item-title>
            <p class="font-weight-light subtitle-1 text-caption">
              <strong>Data da operação:</strong>
              {{ audit.created_at ? dateFormat(audit.created_at) : "- - -" }}
              às {{ audit.created_at ? dateFormatHour(audit.created_at) : "- - -" }}
            </p>
          </v-list-item-title>
          <v-divider v-if="index + 1 != plano.audits.length"></v-divider>
        </v-list>

        <v-divider
          v-if="planoIndex + 1 != planos.length"
          class="my-4"
          style="height: 3px"
        ></v-divider>
      </div>
    </div>

    <v-list-item-title v-else-if="!loading">
      <strong class="subtitle-1 text-caption">Operações não encontradas</strong>
    </v-list-item-title>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters } from "vuex";
import { dateFormat, dateFormatHour } from "@/plugins/filters";

export default {
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    gestao_id: {
      type: Number,
      required: true,
    },
    bimestre: {
      type: Number,
      required: true,
    },
  },
  watch: {
    value() {
      this.localDrawer = this.value;
    },
    localDrawer(val) {
      this.$emit("input", val);
      if (val) {
        this.planos = [];
        this.loading = true;
        this.$nextTick(() => {
          this.historicoPlanosLancados();
        });
      }
    },
  },
  computed: {
    ...mapGetters("Auth", ["user"]),
    podeRestaurarPlano() {
      return this.$constants.rolesParaGestores.find(
        (rpg) =>
          rpg.name ===
          this.user.roles
            .filter((role) => role.name === "super-admin" || role.name === "admin")
            .find((r) => true)?.name
      );
    },
  },
  data() {
    return {
      situacoesPlanos: [
        { id: "1", descricao: "Plano Confirmado", cor: "green" },
        { id: "2", descricao: "Aguardando confirmação", cor: "primary" },
        { id: "3", descricao: "Plano Inválido", cor: "red" },
      ],
      localDrawer: this.value,
      dialog: false,
      planos: [],
      habilidadesMap: {},
      habilidades: [],
      loading: false,
      dateFormat,
      dateFormatHour,
      events: {
        created: "Criado",
        updated: "Atualizado",
        deleted: "Deletado",
        restored: "Restaurado",
      },
    };
  },
  methods: {
    getSituacaoPlano(status_id) {
      const id = String(status_id);
      return (
        this.situacoesPlanos.find((s) => String(s.id) === id) || {
          descricao: "- - -",
          cor: "inherit",
        }
      );
    },
    async historicoPlanosLancados() {
      this.loading = true;
      try {
        const response = await this.$services.gestoesDeAulasService.historicoPlanosLancados(
          this.gestao_id,
          this.bimestre
        );

        this.planos = response.historicoLancamento ?? [];
        this.habilidades = response.habilidades || [];

        this.habilidadesMap = {};
        this.habilidades.forEach((h) => {
          this.habilidadesMap[h.id] = h.descricao;
        });
      } catch (error) {
        this.$handleError(error);
        this.planos = [];
      } finally {
        this.loading = false;
      }
    },

    getDescricaoHabilidade(id) {
      return this.habilidadesMap?.[id] || `ID ${id}`;
    },

    parseArray(value) {
      try {
        return JSON.parse(value);
      } catch (e) {
        return [];
      }
    },

    hasRelevantNewValues(audit) {
      if (!audit || !audit.new_values) return false;

      return Object.entries(audit.new_values).some(([key, value]) => {
        if (["id", "bimestre", "instrutorDisciplinaTurma_id"].includes(key)) return false;

        const stringValue = String(value).trim();
        return !(stringValue === "" || stringValue === "[]" || stringValue === "{}");
      });
    },
    async restaurarPlano(instrutorDisciplinaTurma_id, plano_id, audit_id) {
      this.$modals.danger({
        title: "Cuidado!",
        message: "Tem certeza que deseja restaurar este plano?",
        confirmationCode: plano_id,
        confirmationMessage: `Por favor, digite <strong>${plano_id}</strong> para confirmar`,
        buttons: [
          {
            text: "Cancelar",
            callback: () => {
              this.$modals.close();
            },
            props: {
              color: "warning",
              small: true,
            },
          },
          {
            text: "Confirmar",
            disableIfCodeDoesntMatch: true,
            callback: async () => {
              this.$modals.close();
              this.$loaderService.open("Restaurando Plano");
              try {
                await this.$services.gestoesDeAulasService.restaurarPlano(
                  instrutorDisciplinaTurma_id,
                  plano_id,
                  audit_id
                );
                this.$emit("planoRestaurado");
                this.$toast.success("Plano restaurado com sucesso");
                this.historicoPlanosLancados();
              } catch (error) {
                this.$handleError(error);
              } finally {
                this.$loaderService.close();
              }
            },
            props: {
              color: "error",
              small: true,
            },
          },
        ],
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.my-thick-border {
  border-width: 2px !important;
}
</style>
